import angular from 'angular';

import { ShipmentResource } from './shipment.resource';

angular
  .module('app.global.shipment', ['core.config', 'ngResource'])
  .factory('Shipment', ShipmentResource);
